import { DatapointType, type TechnologyCost, type TechnologyForCost } from '@netpurpose/types'
import type { ImpactThemes, TechnologyBase } from '../../generated/modelling'
import { parseDatapoint } from './datapoint'
import type { BackendDatapoint, BackendTechnologyCost } from './types'

export const parseTechnologyForCost = (technology: TechnologyBase): TechnologyForCost => ({
  id: technology.technology_id || '',
  name: technology.name,
  // TODO: this cast should only be temporary.
  parentId: technology.parent_id as number,
})

export const parseTechnologyCost = (technologyCost: BackendTechnologyCost): TechnologyCost => {
  return {
    ...parseDatapoint(technologyCost as BackendDatapoint),
    type: DatapointType.TechnologyCost,
    numeratorUnitId: technologyCost.numerator_unit_id,
    numeratorReportedUnitId: technologyCost.numerator_reported_unit_id,
    denominatorUnitId: technologyCost.denominator_unit_id,
    denominatorReportedUnitId: technologyCost.denominator_reported_unit_id,
    technology: technologyCost?.technology
      ? parseTechnologyForCost(technologyCost.technology)
      : undefined,
    isPrimaryCost: technologyCost.is_primary_cost,
    impactTheme: technologyCost.impact_theme as ImpactThemes,
    impactQuestionId: technologyCost.impact_question_id,
  }
}
